import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/organisations/OrganisationsPage.vue"),
    meta: {
      accessLevel: "organisation_read",
      title: "Organisations",
    },
    name: "organisations",
    path: "/organisations",
  },
  {
    component: () =>
      import("pages/organisations/OrganisationTabInformation.vue"),
    meta: {
      accessLevel: "organisation_edit",
      title: "Create Organisation",
    },
    name: "organisation-create",
    path: "/organisations/new",
  },
  {
    component: () => import("pages/organisations/UpsellDashboardPage.vue"),
    meta: {
      accessLevel: "super",
      title: "Organisations Upsell Dashboard",
    },
    name: "organisation-upsell-dashboard",
    path: "/organisations/upsell-dashboard",
    props: (route) => typecastRouteProps(route),
  },
  {
    children: [
      {
        component: () => import("pages/organisations/OrganisationTabUsers.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Users",
        },
        name: "organisation-users",
        path: "users",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () => import("pages/organisations/OrganisationTabTeams.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Teams",
        },
        name: "organisation-teams",
        path: "teams",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabImportTeams.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Import Organisation Teams",
        },
        name: "import-organisation-teams",
        path: "import-teams",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabFeatures.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Features",
        },
        name: "organisation-features",
        path: "features",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabContentLicenses.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Content Licenses",
        },
        name: "organisation-content-licenses",
        path: "content_licenses",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabManagedBriefs.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Managed Briefs",
        },
        name: "organisation-managed-briefs",
        path: "managed-briefs",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabInformation.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Information",
        },
        name: "organisation-information",
        path: "information",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabBrands.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Brands",
        },
        name: "organisation-brands",
        path: "organisation-brands",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabMentionStreams.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Mention Streams",
        },
        name: "organisation-mention-streams",
        path: "mention-streams",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabBookmarkStreams.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Tagged Streams",
        },
        name: "organisation-bookmark-streams",
        path: "bookmark-streams",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabBookmarkStreamsImport.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Tagged Streams Import",
        },
        name: "organisation-bookmark-streams-import",
        path: "organisation-bookmark-streams-import",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabNotifications.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Notifications",
        },
        name: "organisation-notifications",
        path: "notifications",
        props: (route) => typecastRouteProps(route),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabScheduledReports.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Scheduled Reports",
        },
        name: "organisation-scheduled-reports",
        path: "scheduled-reports",
        props: (route) => ({
          view: route.query.view,
          ...route.params,
          ...route.query,
        }),
      },
      {
        component: () => import("pages/organisations/OrganisationTabStats.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Stats",
        },
        name: "organisation-stats",
        path: "stats",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabActivities.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Activities",
        },
        name: "organisation-activities",
        path: "activities",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabDistributionLists.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Distribution Lists",
        },
        name: "organisation-distribution-lists",
        path: "distribution-lists",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabTranscriptTemplates.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Organisation Transcript Templates",
        },
        name: "organisation-transcript-templates",
        path: "transcript-templates",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabTranscriptTurnaroundTimes.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Organisation Transcript Turnaround Times",
        },
        name: "organisation-transcript-turnaround-times",
        path: "transcript-turnaround-times",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () => import("pages/organisations/UpsellRegistrations.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Organisation Upsell Registrations",
        },
        name: "upsell-registrations",
        path: "upsell-registrations",
        props: (route) => typecastRouteProps(route),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabContractsAndBilling.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Contracts & Billing",
        },
        name: "organisation-contracts",
        path: "contracts",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabManagers.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Managers",
        },
        name: "organisations-managers",
        path: "managers",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () => import("pages/InvoiceList.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Organisation Invoices",
        },
        name: "organisation-invoices",
        path: "invoices",
        props: (route) => ({
          ...route.params,
          ...route.query,
          hideOrganisationsDropdown: true,
          organisationId: [route.params.organisationId],
        }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabUsageAndAllowance.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Usage & Allowance",
        },
        name: "organisation-usage",
        path: "usage",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabFilterSets.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Filter Sets",
        },
        name: "organisation-filter-sets",
        path: "filter-sets",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabBriefGroups.vue"),
        meta: {
          accessLevel: "organisation_read",
          angularName: "app.brief_groups.index",
          title: "Brief Groups",
        },
        name: "organisation-brief-groups",
        path: "brief-groups",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabBriefSets.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Brief Sets",
        },
        name: "organisation-brief-sets",
        path: "brief-sets",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabSocialStreams.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Social Streams",
        },
        name: "organisation-social-streams",
        path: "social-streams",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabQuerySnippetGroups.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Query Snippet Groups",
        },
        name: "organisation-query-snippet-groups",
        path: "query-snippet-groups",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabQuerySnippets.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Query Snippets",
        },
        name: "organisation-query-snippets",
        path: "query-snippets",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabClients.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Clients",
        },
        name: "organisation-clients",
        path: "clients",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabOutreachMigrator.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Outreach Migrator",
        },
        name: "organisation-outreach-migrator",
        path: "outreach-migrator",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabInstantInsights.vue"),
        meta: {
          accessLevel: "organisation_edit",
          title: "Instant Insights",
        },
        name: "organisation-instant-insights",
        path: "instant-insights",
        props: (route) => ({ ...route.params, ...route.query }),
      },
      {
        component: () =>
          import("pages/organisations/OrganisationTabOutreachActivity.vue"),
        meta: {
          accessLevel: "organisation_read",
          title: "Organisation Outreach Activity",
        },
        name: "organisation-archived-outreach-activity",
        path: "archived-outreach-activity",
        props: (route) => ({ ...route.params, ...route.query }),
      },
    ],
    component: () => import("pages/organisations/OrganisationTabs.vue"),
    meta: {
      title: "Edit Organisation",
    },
    name: "organisation-tab",
    path: "/organisations/:organisationId/edit",
    props: true,
  },
];
